<template>
  <div class="flex-grid create_mailer">
    <div
      v-show="isPopup"
      class="popup"
    >
      <div class="popup-data">
        <label for="menuName">
          <b>Enter Number Of Blocks</b>
        </label>
        <br>
        <br>
        <input
          v-model="blocksCount"
          type="number"
          min="1"
          name="menuName"
          required
          class="slices_number"
        >
        <div class="btns-container">
          <button @click="addRow()">
            Ok
          </button>
          <button @click="cancel()">
            Cancel
          </button>
        </div>
      </div>
    </div>
    <div class="col2">
      <input
        v-model="mailerName"
        type="text"
        placeholder="Enter Mailer"
        name="mailerName"
        required
      >
      <select
        v-model="fascia"
        @change="fasciaChange()"
      >
        <option value>
          Select Fascia
        </option>
        <option
          v-for="(fascias, key) in fasciasList"
          :key="key"
          :value="fascias._id"
        >
          {{ fascias.fasica_name }}
        </option>
      </select>
      <select
        v-model="category"
        style="display: inline;"
        @change="categoryChange()"
      >
        <option value>
          Select Category
        </option>
        <option
          v-for="(cate, key) in categories"
          :key="key"
          :value="cate"
        >
          {{ getCategoryName(cate) }}
        </option>
      </select>
      <div>
        <input
          v-model="isPrefix"
          type="checkbox"
          @click="checkPrefix()"
        >
        {{ prefixLabel }}
        <br>
        <div v-show="isPrefix">
          <input
            v-model="prefixPath"
            type="text"
            placeholder="Enter Prefix Path"
            name="Prefix"
            required
          >
          <a
            class="button_create"
            @click="applyJobs()"
          >Apply for all jobs</a>
        </div>
      </div>
      <table class="table table-striped">
        <thead class="thead-dark">
          <tr>
            <th scope="col">
              Row
            </th>
            <th scope="col">
              Blocks
            </th>
            <th scope="col">
              Actions
            </th>
          </tr>
        </thead>
        <Draggable
          v-model="rowsData"
          class="spot_slots"
          tag="tbody"
          @end="onEnd()"
        >
          <tr
            v-for="(row, key) in rowsData"
            :key="key"
          >
            <td width="1%">
              {{ key+1 }}
            </td>
            <td>
              Block{{ key+1 }}
              <tr>
                <td>
                  <table
                    v-for="(rowBlock, key1) in row.blocks"
                    :key="key1"
                  >
                    <tr>
                      <td>
                        <input
                          v-model="imageurls[key.toString()+key1]"
                          type="text"
                          placeholder="Enter Image Path"
                          name="imagePath"
                        >
                        <input
                          v-model="urls[key.toString()+key1]"
                          type="text"
                          placeholder="Enter URL"
                          name="url"
                        >
                      </td>
                      <td>
                        <img
                          v-if="imageurls[key.toString()+key1]==='' ||
                            imageurls[key.toString()+key1] === undefined"
                          class="img-preview"
                          src="../assets/nopreview.jpg"
                        >
                      </td>
                      <td>
                        <img
                          v-if="imageurls[key.toString()+key1]!='' &&
                            imageurls[key.toString()+key1] !== undefined"
                          class="img-preview"
                          :src="imageurls[key.toString()+key1]"
                        >
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </td>
            <td>
              <a
                class="button"
                @click="addBelowRow(key)"
              >Add</a>
              <a
                class="button"
                @click="deleteRow(key)"
              >Delete</a>
              <a
                class="button"
                @click="duplicateRow(key)"
              >Duplicate</a>
            </td>
          </tr>
        </Draggable>
      </table>
      <div class="btns-container">
        <a
          class="button_create"
          @click="saveMailer()"
        >{{ btnName }}</a>
        <a
          class="button_create"
          @click="addSingleRow()"
        >Add Single Row</a>
      </div>
    </div>
    <div class="col3">
      <table
        v-for="(row, key) in rowsData"
        :key="key"
      >
        <tr>
          <td
            v-for="(rowBlock, key1) in row.blocks"
            :key="key1"
          >
            <img
              style="width: 100%;"
              :src="imageurls[key.toString()+key1]"
            >
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import Draggable from 'vuedraggable';

export default {
  name: 'CreateMailers',
  components: {
    Draggable,
  },
  data() {
    return {
      userID: '',
      roleID: '',
      isUpdate: false,
      isPopup: false,
      fascia: '',
      isPrefix: false,
      prefixPath: '',
      prefixLabel: 'Enable Prefix Path Facility',
      category: '',
      mailerName: '',
      imageurls: {},
      urls: {},
      categories: [],
      selectboxes: {},
      blocksCount: 1,
      rowsData: [],
      mailerJson: [],
      fasciaTemplate: '',
      fasciasList: [],
      categoryList: [],
      btnName: 'Create',
      addbelowrow: false,
      selectedIndex: '',
    };
  },
  created() {
    this.$eventHub.$on('userData', this.getCurrentUser);
  },
  beforeDestroy() {
    this.$eventHub.$off('userData');
  },
  mounted() {
    const getMasterData = () => {
      this.getCurrentUser();
      return new Promise((resolve) => {
        fetch('/api/categorylist/all', { credentials: 'same-origin' })
          .then(response => response.json())
          .then((responseJSON) => {
            this.categoryList = responseJSON;
          });
        fetch('/api/getUserData', { credentials: 'same-origin' })
          .then(response => response.json())
          .then((responseJSON) => {
            this.roleID = responseJSON.data.role_id;
            this.userID = responseJSON.data.id;
          });
        setTimeout(() => resolve(), 1000);
      });
    };
    getMasterData().then(() => {
      if (this.roleID === 2 || this.roleID === 3) {
        const getfascias = fetch('/api/fascias/all', {
          credentials: 'same-origin',
        });
        getfascias
          .then(data => data.json())
          .then((data) => {
            this.fasciasList = data;
          });
      } else {
        const getProfile = fetch(`/api/users/${this.userID}`, {
          credentials: 'same-origin',
        });
        getProfile
          .then(data => data.json())
          .then((data) => {
            this.fasciasList = data.fascias;
          });
      }
      this.rowsData = [];
      if (this.$route.query.id) {
        this.btnName = 'Update';
        this.isUpdate = true;
        const getMailer = fetch(`/api/mailers/${this.$route.query.id}/1`, {
          credentials: 'same-origin',
        });
        getMailer
          .then(data => data.json())
          .then((data) => {
            this.mailerName = data.mailer_name;
            this.fascia = data.fascia_id;
            this.fasciaChange();
            this.category = data.template_category;
            this.rowsData = JSON.parse(data.mailer_json_data);
            this.formDataJson();
          });
      }
    });
  },
  methods: {
    getCurrentUser(userData) {
      // you don't have to pass it again from the listener.
      if (userData) {
        this.roleID = userData.role_id;
        this.userID = userData.id;
      }
    },
    duplicateRow(index) {
      this.blocksCount = this.rowsData[index].blocks.length;
      this.addRow(index);
    },
    addBelowRow(key) {
      this.isPopup = true;
      this.addbelowrow = true;
      this.selectedIndex = key;
    },
    formDataJson() {
      this.rowsData.forEach((row, index) => {
        const keyStr1 = index;
        row.blocks.forEach((column, innerIndex) => {
          const keyStr2 = innerIndex;
          const strKey = `${keyStr1}${keyStr2}`;
          this.$set(this.imageurls, `${strKey}`, column.imageurls);
          this.$set(this.urls, `${strKey}`, column.url);
        });
      });
    },
    categoryChange() {
      const template = fetch(
        `/api/fasciaTemplatesByfacia/${this.fascia}/${this.category}`,
        { credentials: 'same-origin' },
      );
      template
        .then(data => data.json())
        .then((data) => {
          this.fasciaTemplate = data[0]._id;
        });
    },
    getCategoryName(id) {
      const filteredCategory = this.categoryList.filter(
        category => category._id === id,
      );
      return filteredCategory[0].categoryName;
    },
    applyJobs() {
      const imageSplit = this.prefixPath.split('_01');
      const imagePart = imageSplit[0];
      let count = 1;
      this.rowsData.forEach((row, index) => {
        const keyStr1 = index;
        row.blocks.forEach((column, innerIndex) => {
          const keyStr2 = innerIndex;
          const strKey = `${keyStr1}${keyStr2}`;
          let tempKey = 0;
          if (count < 10) {
            tempKey = `0${count}`;
          } else {
            tempKey = `${count}`;
          }
          this.$set(this.imageurls, `${strKey}`, `${imagePart}_${tempKey}.jpg`);
          count += 1;
        });
      });
    },
    fasciaChange() {
      if (this.fascia === '') {
        this.categories = [];
        return false;
      }
      const getfascias = fetch(`/api/templateCategories/${this.fascia}`, {
        credentials: 'same-origin',
      });
      getfascias
        .then(data => data.json())
        .then((data) => {
          this.categories = [];
          data.forEach((cat) => {
            this.categories.push(cat.category);
          });
        });
      return true;
    },
    addSingleRow() {
      // window.scrollTo(0, 0);
      this.isPopup = true;
    },
    cancel() {
      this.isPopup = false;
      this.blocksCount = 1;
      this.selectedIndex = '';
      this.addbelowrow = false;
    },
    deleteRow(index) {
      this.rowsData.splice(index, 1);
      this.urls = {};
      this.imageurls = {};
      this.formDataJson();
      this.configToJson();
    },
    addRow(index = null) {
      if (this.addbelowrow) {
        const dupRows = [];
        const newBlocks = [];
        let rowId = 0;
        for (let i = 0; i < this.blocksCount; i += 1) {
          newBlocks.push({
            id: i,
            name: '',
            url: '',
          });
        }

        this.rowsData.forEach((row, i) => {
          if (this.selectedIndex === i) {
            dupRows.push({ id: rowId, blocks: row.blocks });
            rowId += 1;
            dupRows.push({ id: rowId, blocks: newBlocks });
          } else {
            rowId += 1;
            dupRows.push({ id: rowId, blocks: row.blocks });
          }
        });
        this.rowsData = [];
        this.urls = {};
        dupRows.forEach((dupRow, dupId) => {
          const key1 = dupId;
          this.rowsData.push(dupRow);
          dupRow.blocks.forEach((column, innerIndex) => {
            const key2 = innerIndex;
            this.imageurls[`${key1}${key2}`] = column.imageurls;
            this.urls[`${key1}${key2}`] = column.url;
          });
        });
        this.urls = {};
        this.imageurls = {};
        this.formDataJson();

        this.addbelowrow = false;
      } else if (index === null) {
        const blocks = [];
        for (let i = 0; i < this.blocksCount; i += 1) {
          blocks.push({
            id: i,
            name: '',
            url: '',
          });
        }
        this.$set(this.selectboxes, `${this.rowsData.length}`, blocks.length);
        blocks.forEach((data) => {
          this.$set(this.imageurls, `${this.rowsData.length}${data.id}`, '');
          this.$set(this.urls, `${this.rowsData.length}${data.id}`, '');
        });
        this.rowsData.push({ id: this.rowsData.length, blocks });
      } else {
        const dupRows = [];
        let rowId = 0;
        this.rowsData.forEach((row, i) => {
          const keyStr1 = i;
          row.blocks.forEach((column, innerIndex) => {
            const keyStr2 = innerIndex;
            const strKey = `${keyStr1}${keyStr2}`;
            this.rowsData[`${keyStr1}`].blocks[`${keyStr2}`].url = this.urls[
              strKey
            ];
            this.rowsData[`${keyStr1}`].blocks[
              `${keyStr2}`
            ].imageurls = this.imageurls[strKey];
          });
          if (index === i) {
            dupRows.push({ id: rowId, blocks: row.blocks });
            rowId += 1;
            dupRows.push({ id: rowId, blocks: row.blocks });
          } else {
            rowId += 1;
            dupRows.push({ id: rowId, blocks: row.blocks });
          }
        });
        this.rowsData = [];
        this.urls = {};
        dupRows.forEach((dupRow, dupId) => {
          const key1 = dupId;
          this.rowsData.push(dupRow);
          dupRow.blocks.forEach((column, innerIndex) => {
            const key2 = innerIndex;
            this.imageurls[`${key1}${key2}`] = column.imageurls;
            this.urls[`${key1}${key2}`] = column.url;
          });
        });
        this.urls = {};
        this.imageurls = {};
        this.formDataJson();
      }
      this.blocksCount = 1;
      this.isPopup = false;
    },
    onEnd() {
      this.rowsData.forEach((row) => {
        row.blocks.forEach((data) => {
          this.$set(this.imageurls, `${this.rowsData.length}${data.id}`, '');
          this.$set(this.urls, `${this.rowsData.length}${data.id}`, '');
        });
      });
      this.urls = {};
      this.imageurls = {};
      this.formDataJson();
    },
    checkPrefix() {
      if (!this.isPrefix) {
        this.prefixLabel = 'Disable Prefix Path Facility';
      } else {
        this.prefixLabel = 'Enable Prefix Path Facility';
      }
    },
    configToJson() {
      this.rowsData.forEach((row, index) => {
        const keyStr1 = index;
        row.blocks.forEach((column, innerIndex) => {
          const keyStr2 = innerIndex;
          const strKey = `${keyStr1}${keyStr2}`;
          this.rowsData[`${keyStr1}`].blocks[`${keyStr2}`].url = this.urls[
            strKey
          ];
          this.rowsData[`${keyStr1}`].blocks[
            `${keyStr2}`
          ].imageurls = this.imageurls[strKey];
        });
      });
    },
    saveMailer() {
      if (this.mailerName === '') {
        this.$toasted.error('Please Enter Mailer Name', { duration: 3000 });
        return true;
      }
      if (this.fascia === '') {
        this.$toasted.error('Please select fascia', { duration: 3000 });
        return true;
      }
      if (this.category === '') {
        this.$toasted.error('Please select Category', { duration: 3000 });
        return true;
      }
      this.configToJson();
      let url = '/api/createMailer';
      const inputData = {
        fasciaId: this.fascia,
        templateId: this.fasciaTemplate,
        templateCategory: this.category,
        mailerName: this.mailerName,
        mailerJson: JSON.stringify(this.rowsData),
      };
      let currentMethod = 'POST';
      if (this.isUpdate) {
        currentMethod = 'PUT';
        url = `/api/createMailer/${this.$route.query.id}`;
      }
      fetch(url, {
        method: currentMethod, // or 'PUT'
        body: JSON.stringify(inputData), // data can be `string` or {object}!
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => res.json())
        .catch(error => this.$toasted.error(
          `Something Went Wrong. Please try again - ${error}`,
          { duration: 3000 },
        ))
        .then(response => this.$toasted.success(response.message, { duration: 3000 }))
        .then(
          setTimeout(() => this.$router.push({ name: 'prepareMailers' }), 3000),
        );
      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.img-preview {
  max-width: 100%;
  border: 1px solid black;
  padding: 5px;
  margin: 5px;
  height: auto;
  vertical-align: middle;
}

.button {
  background-color: #000;
  border: none;
  color: white;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 90%;
  border: 1px solid #ddd;
}

.btns-container {
  margin-top: 5%;
}

.icon {
  cursor: pointer;
  margin-left: 10px;
}

th,
td {
  text-align: center;
  padding: 16px;
  border: 1px solid gray;
}

th:first-child,
td:first-child {
  text-align: left;
}

/* tr:nth-child(even) {
    background-color: #f2f2f2
} */
.flex-grid {
  display: flex;
  justify-content: space-between;
}

.col2 {
  width: 80%;
  float: left;
  margin-left: 2%;
}

.col3 {
  float: left;
  width: 16%;
  margin-top: 3%;
}

.popup {
  width: 100%;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
}

.popup-content {
  margin: auto;
  margin-top: 10%;
  width: 20%;
  border-radius: 10px;
  background-color: white;
  height: 200px;
}

.popup-fields {
  margin: auto;
  position: relative;
  top: 65px;
  width: 50%;
}

.create_mailer input[type="text"],
.create_mailer select {
  display: inline-block;
  width: auto;
}

.slices_number {
  width: auto;
  display: inline-block;
}
</style>
